import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import ContactUsMessagesPage from 'containers/pages/webManagement/contactUsMessages/List'
import ContactUsMessagesForm from 'containers/pages/webManagement/contactUsMessages/Form'

const ContactUsMes = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/web-management/contact-us-messages') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementsimpan-messages-read') > -1) {
      return <ContactUsMessagesPage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-web-managementsimpan-messages-write') > -1) {
      return <ContactUsMessagesForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

ContactUsMes.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default ContactUsMes
